import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import app from "../../../firebaseConfig";
import { useNavigate } from "react-router-dom";

import ProteccionPedidos from "./proteccionpedidos";

const AwooPedidoInterfaz = () => {
  const [categorias, setCategorias] = useState({});
  const [carrito, setCarrito] = useState([]);
  const [mesa, setMesa] = useState("");
  const [maxMesas, setMaxMesas] = useState(0);

  const [empleados, setEmpleados] = useState([]);
  const [notaPedido, setNotaPedido] = useState("");
  const [empleado, setEmpleado] = useState("-- Selecciona --");
  const [nota, setNota] = useState("");
  const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(""); // valor por defecto vacío



  const db = getDatabase(app);
  const navigate = useNavigate();

  useEffect(() => {
    const categoriasRef = ref(db, "nature/Awoo/Categorias");
    onValue(categoriasRef, (snapshot) => {
      const data = snapshot.val();
      if (data) setCategorias(data);
    });

    const mesasRef = ref(db, "nature/Awoo/Mesas");
    onValue(mesasRef, (snapshot) => {
      const data = snapshot.val();
      if (data) setMaxMesas(Object.keys(data).length);
    });

   // Recuperar carrito y mesa del localStorage
   const datosCarrito = localStorage.getItem("carrito");
   if (datosCarrito) {
     setCarrito(JSON.parse(datosCarrito));
   }

   const mesaGuardada = localStorage.getItem("mesa");
   if (mesaGuardada) setMesa(mesaGuardada);
 }, []);


 ///////////Recuperar datos
 useEffect(() => {
  if (!empleado && localStorage.getItem("empleado")) {
    setEmpleado(localStorage.getItem("empleado"));
  }
  if (!nota && localStorage.getItem("nota")) {
    setNota(localStorage.getItem("nota"));
  }
}, []);


 //////////////////////////////////////
 useEffect(() => {
  const empleadoGuardado = localStorage.getItem("empleado");
  if (empleadoGuardado) setEmpleado(empleadoGuardado);

  const notaGuardada = localStorage.getItem("nota");
  if (notaGuardada) setNota(notaGuardada);
}, []);


 ////////////////////////////////
 // Cargar nombres de empleados
useEffect(() => {
  const personalRef = ref(db, "nature/Awoo/Control/Personal");
  onValue(personalRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const nombres = Object.values(data).map((p) => p.nombre);
      setEmpleados(nombres);
    }
  });

  // Puedes guardar y recuperar nota y empleado si deseas persistencia también:
  const notaGuardada = localStorage.getItem("notaPedido");
  if (notaGuardada) setNotaPedido(notaGuardada);

  const empGuardado = localStorage.getItem("empleado");
  if (empGuardado) setEmpleado(empGuardado);

}, []);

const handleEmpleadoChange = (e) => {
  setEmpleado(e.target.value);
  localStorage.setItem("empleado", e.target.value);
};

const handleNotaChange = (e) => {
  setNotaPedido(e.target.value);
  localStorage.setItem("notaPedido", e.target.value);
};



///////////////////////
const guardarEmpleado = (valor) => {
  setEmpleado(valor);
  localStorage.setItem("empleado", valor);
};

const guardarNota = (valor) => {
  setNota(valor);
  localStorage.setItem("nota", valor);
};

 ////////////////////////

  const guardarCarrito = (nuevoCarrito) => {
    setCarrito(nuevoCarrito);
    localStorage.setItem("carrito", JSON.stringify(nuevoCarrito));
  };

  const toggleProducto = (categoria, producto, datos) => {
    const existe = carrito.find(
      (item) => item.producto === producto && item.categoria === categoria
    );

    if (existe) {
      const nuevo = carrito.filter(
        (item) => !(item.producto === producto && item.categoria === categoria)
      );
      guardarCarrito(nuevo);
    } else {
      const nuevoProducto = {
        categoria,
        producto,
        cantidad: 1,
        Img: datos.Img,
        Titulo: datos.Titulo,
        Descripcion: datos.Descripción,
        Precio: datos.Precio,
        Costo: datos.Costo,
        
      };
      guardarCarrito([...carrito, nuevoProducto]);
    }
  };

  const cambiarCantidad = (categoria, producto, cantidad) => {
    const nuevoCarrito = carrito.map((item) => {
      if (item.categoria === categoria && item.producto === producto) {
        return { ...item, cantidad: Math.max(1, item.cantidad + cantidad) };
      }
      return item;
    });
    guardarCarrito(nuevoCarrito);
  };

  const calcularTotal = () => {
    return carrito.reduce((acc, item) => acc + item.Precio * item.cantidad, 0);
  };

  const estaSeleccionado = (categoria, producto) => {
    return carrito.some(
      (item) => item.producto === producto && item.categoria === categoria
    );
  };

  const handleMesaChange = (e) => {
    const valor = e.target.value;
    if (!/^\d*$/.test(valor)) return;

    const num = parseInt(valor);
    if (valor === "" || (num > 0 && num <= maxMesas)) {
      setMesa(valor);
      localStorage.setItem("mesa", valor);
    }
  };

  const mesaValida = () => {
    const num = parseInt(mesa);
    return num > 0 && num <= maxMesas;
  };

  const irAlResumen = () => {
    if (!mesaValida()) {
      alert("⚠️ Por favor ingresa un número de mesa válido.");
      return;
    }
  
    if (!empleado || empleado === "Selecciona" || empleado === "-- Selecciona --") {
      alert("⚠️ Debes seleccionar meser@.");
      return;
    }
    
  
    if (window.confirm("¿Estás seguro de que tomaste los pedidos?")) {
      navigate("/3dfyrionresumen", {
        state: {
          mesa,
          empleado,
          nota,
      origen: "interfaz2", // <- Esto le indica de dónde viene
        },
      });
    }
  };
  

  return (

    
    <ProteccionPedidos>

<div style={{ padding: 20, color: "#333" }}>

<div style={{ color: "#fff", fontSize: 24, fontWeight: "bold", marginBottom: 20 }}>
  🧾 Tabla de Pedidos
</div>

      {/* Campo para ingresar la mesa */}
      <div style={{ marginBottom: 20 }}>
        <label style={{ color: "#fff", marginRight: 10 }}>
          Número de Mesa:
        </label>
        <input
          type="text"
          value={mesa}
          onChange={handleMesaChange}
          placeholder={`1 a ${maxMesas}`}
          style={{
            padding: 8,
            borderRadius: 6,
            border: "2px solid #21dbf0",
            width: 100,
            fontSize: 16,
            fontWeight: "bold",
            color: "#000",
          }}
        />
      </div>


{/* Selección de empleado */}
<div style={{ marginBottom: 20 }}>
  <label style={{ color: "#fff", marginRight: 10 }}>Meser@ que toma el pedido:</label>
  <select
  value={empleado}
  onChange={(e) => guardarEmpleado(e.target.value)}
  required
  style={{ padding: 8, borderRadius: 6, border: "2px solid #21dbf0", fontWeight: "bold" }}
>
  <option value="-- Selecciona --" disabled>-- Selecciona --</option>
  {empleados.map((nombre) => (
    <option key={nombre} value={nombre}>{nombre}</option>
  ))}
</select>


</div>

{/* Campo de nota */}
<div style={{ marginBottom: 20 }}>
  <label style={{ color: "#fff", marginRight: 10 }}>Notas del pedido:</label>
  <textarea
  value={nota}
  onChange={(e) => guardarNota(e.target.value)}
  placeholder="Escribe una nota sobre el pedido (opcional)"
  rows={4}
  style={{ width: "100%", padding: 10, borderRadius: 6, border: "2px solid #21dbf0", fontSize: 16 }}
/>

</div>



  {Object.entries(categorias).map(([categoria, productos]) => (
    <div key={categoria} style={{ marginBottom: 30 }}>
      <h3 style={{ color: "#fff", marginLeft: 15 }}>{categoria}</h3>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {Object.entries(productos).map(([nombre, datos]) => {
          const enCarrito = carrito.find(
            (item) => item.producto === nombre && item.categoria === categoria
          );
          const cantidad = enCarrito?.cantidad || 0;
          const seleccionado = cantidad > 0;

          return (
<div
  key={nombre}
  style={{
    display: "flex",
    alignItems: "center",
    padding: 10,
    margin: "0 10px",
    backgroundColor: seleccionado ? "#75cc17" : "#fff",
    color: seleccionado ? "#000" : "#000",
    borderRadius: 10,
    border: seleccionado ? "2px solid #fff" : "2px solid #21dbf0",
    boxShadow: seleccionado ? "0 0 10px #fff" : "0 0 10px #21dbf0",
    transition: "all 0.3s ease",
    gap: 10,
    cursor: "pointer",
    transform: "scale(1)",
  }}
  onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.02)")}
  onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
>


<input
  type="checkbox"
  checked={seleccionado}
  onChange={() => toggleProducto(categoria, nombre, datos)}
  style={{
    transform: "scale(1.8)",
    accentColor: seleccionado ? "#ffffff" : "#21dbf0", // cambia el color del checkbox
    cursor: "pointer",
  }}
/>

  {/* Imagen del producto */}
  <img
    src={datos.Img}
    alt={datos.Titulo}
    style={{
      width: 50,
      height: 50,
      objectFit: "cover",
      borderRadius: 5,
      border: "1px solid #ccc",
    }}
  />

  {/* Texto del producto */}
  <div style={{ flex: 1 }}>
    <strong>{datos.Titulo}</strong>
    <div>
  {datos.Precio.toLocaleString("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })}
</div>


  </div>

  {/* Controles de cantidad */}
  <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
    <button
      onClick={() =>
        cambiarCantidad(categoria, nombre,- 1)
      }
      disabled={!seleccionado || cantidad <= 0}
      style={{
        backgroundColor: seleccionado ? "#fff" : "#21dbf0",
        color: seleccionado ? "#000" : "#fff",
        border: "none",
        padding: "5px 10px",
        borderRadius: 5,
        cursor: "pointer",
      }}
    >
      -
    </button>

    <span>{cantidad}</span>

    <button
      onClick={() =>
        cambiarCantidad(categoria, nombre, 1)
      }
      disabled={!seleccionado}
      style={{
        backgroundColor: seleccionado ? "#fff" : "#21dbf0",
        color: seleccionado ? "#000" : "#fff",
        border: "none",
        padding: "5px 10px",
        borderRadius: 5,
        cursor: "pointer",
      }}
    >
      +
    </button>
  </div>
</div>

          );
        })}
      </div>
      {/* Espacio para que el último producto no quede oculto por la barra */}
      <div style={{ height: "25px" }}></div>
    </div>
  ))}

      {/* Pie de resumen */}
      {carrito.length > 0 && (
        
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "#2ddaee",
            color: "#000",
            padding: 15,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 -2px 5px rgba(0,0,0,0.1)",
          }}
        >
          <strong>Total: ${calcularTotal().toLocaleString()}</strong>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#78cb1e",
              color: "#fff",
              fontWeight: "bold",
              borderRadius: 8,
              border: "none",
              cursor: "pointer",
            }}
            
            onClick={irAlResumen}
          >
            Revisar Pedido
          </button>
        </div>
      )}
    </div>
        
    </ProteccionPedidos>


  );
};

export default AwooPedidoInterfaz;
